"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rxObject = void 0;
const rxjs_1 = require("rxjs");
const lens_1 = require("@rixio/lens");
const domain_1 = require("./domain");
const operators_1 = require("./operators");
const utils_1 = require("./utils");
function rxObject(lifted) {
    const observables = [];
    const lenses = [];
    walk(lifted, (value, lens) => {
        if (value instanceof rxjs_1.Observable) {
            observables.push(value);
            lenses.push(lens);
        }
    });
    if (observables.length === 0) {
        return utils_1.markWrappedObservable(rxjs_1.of(domain_1.createFulfilledWrapped(lifted)));
    }
    return operators_1.combineLatest(observables).pipe(operators_1.map(values => lenses.reduce((acc, l, idx) => l.set(values[idx], acc), lifted)));
}
exports.rxObject = rxObject;
function walk(props, handler) {
    for (const key in props) {
        if (props.hasOwnProperty(key)) {
            const prop = props[key];
            handler(prop, lens_1.Lens.key(key));
        }
    }
}
